import {useNavigate, useParams} from "react-router-dom";
import {fetchWithToken, postWithToken} from "../../api/apiBase";
import {useAuthInfo} from "@propelauth/react";
import React, {useEffect, useState} from "react";
import {BaseScopeModel, FullScopeModel} from "./ScopeModel";
import ScopeItemForm from "./CreateScope";
import {DevBidFormConfig} from "../project_conf/BidCustomDataConf";
import {Button} from "../ui/button";
import {blank_bid} from "../bid/bidding_model";
import DataSheet from "../project_conf/DataSheet";
import {Cell, cellsDecoder} from "../project_conf/bidConfig_model";
import {SubmitHandler} from "react-hook-form";
import {useToast} from "../ui/use-toast";
import InviteBidderByEmail from "../directory/InviteByEmail";
import {ScopeForm} from "./ScopeForm";
import {Card, CardContent, CardHeader, CardTitle} from "../ui/card";
import {EdtSaveButtonToggle} from "../ui/EdtSaveButtonToggle";
import BidSummary from "../bid/BiddingSummaryView";
import AuctionStatusView from "../builder/AuctionStatusView";
import {DeveloperBidSummarySD, ScopedDeveloperBidSummarySD} from "../bid/DeveloperBidSummaryView";


export function DeveloperScopeView() {
    const {accessToken} = useAuthInfo();
    const {project_id, scope_id} = useParams<string>();
    const {toast} = useToast();
    const [data, setData] = useState<FullScopeModel | null>(null);
    // const [isEditing, setIsEditing] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            if (accessToken) {
                try {
                    setIsLoading(true);
                    const response = await fetchWithToken(
                        `/projects/${project_id}/scope/${scope_id}`, accessToken);
                    setData(response);
                    setError(null);
                } catch (err) {
                    setError("Error loading Scope :(");
                } finally {
                    setIsLoading(false);
                }
            }
        };
        fetchData();
    }, [project_id, scope_id]);

    const handleSaveEdit = (newData: FullScopeModel) => {
        if (!accessToken) {
            return
        }
        // console.log(newData)
        postWithToken(
            `/projects/${project_id}/scope/${scope_id}`,
            JSON.stringify(newData),
            accessToken)
            .then((data) => {
                setData(newData)
                toast({
                    title: "Success!",
                    description: "Update successful",
                    variant: "default",
                });

            })
            .catch((error) => {
                toast({
                    title: "Error",
                    description: error.message || "Failed to update Scope.",
                    variant: "destructive",
                });
            });
    };


    const onInvite = () => {
    }

    return <>
        <Card>
                {data ?
                    <ScopeForm
                        editable={true}
                        onSave={handleSaveEdit}

                        onSubmit={handleSaveEdit}
                        scope={data as FullScopeModel}
                        canInvite={true}
                        create={false}
                        onInvite={onInvite}
                    />
                    : <></>
                }
            {/*</CardContent>*/}
        </Card>
        <br/>

        {/*Sumamry/invites*/}
        <Card>
            <CardHeader>
                <CardTitle>
                    Bid Summary
                </CardTitle>
            </CardHeader>
            <CardContent>
                <ScopedDeveloperBidSummarySD/>
            </CardContent>
        </Card>
        <br/>

        {/*bid config*/}
        <DevBidFormConfig/>

    </>
}

// -----------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------
export function BidderScopeView() {
    const navigate = useNavigate();
    const {accessToken} = useAuthInfo();
    const {project_id, scope_id} = useParams<string>();
    const [feedback, setFeedback] = useState<any | null>(null);
    const [round, setRound] = useState<any | null>(null);
    const [data, setData] = useState<FullScopeModel | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [sheetData, setSheetData] = useState<Cell[][]>([]);

    useEffect(() => {
        const fetchData = async () => {
            if (accessToken) {
                try {
                    setIsLoading(true);
                    const [response, config, summary, round] = await Promise.all([
                        fetchWithToken(`/projects/${project_id}/scope/${scope_id}`, accessToken),
                        fetchWithToken(`/projects/${project_id}/scope/${scope_id}/bid_config`, accessToken),
                        fetchWithToken(`/projects/${project_id}/feedback/?scope_id=${scope_id}`, accessToken),
                        fetchWithToken(`/projects/${project_id}/current_round`, accessToken)
                    ]);
                    setData(response);
                    setSheetData(cellsDecoder(config.cells));
                    setFeedback(summary);
                    setRound(round);
                    setError(null);

                } catch (err) {
                    setError("Error loading scopes");
                } finally {
                    setIsLoading(false);
                }
            }
        };
        fetchData();
    }, [project_id, scope_id]);


    const onCreateBid = () => {
        postWithToken(
            `/projects/${project_id}/scope/${scope_id}/bidding/create`,
            JSON.stringify(blank_bid()),
            accessToken as string
        )
            .then((new_data) => {
                // console.log(new_data)
                navigate(`/project/${project_id}/bid/${new_data.id}`);
            })
            .catch((error) => {
                console.error("Error creating bid:", error);
            });
    };

    const noop = (a: any) => {
    }

    return <><Card>
            {data ?
                <ScopeForm
                    editable={false}
                    onSave={noop}
                    onSubmit={noop}
                    onCreateBid={onCreateBid}
                    scope={data as FullScopeModel}
                    create={false}
                /> : <></>}

    </Card>
        {/*Summary data*/}
        <br/>
        {round && feedback ?
            <AuctionStatusView
                round={round}
                bidViewData={feedback}/>
            : <></>
        }
        <Card>
            <CardContent>
                <BidSummary/>
            </CardContent>
        </Card>
        <br/>
        <Card>
            {/*bid config*/}
            <CardHeader>
                <CardTitle>Requirements</CardTitle>
            </CardHeader>
            <CardContent>
                <DataSheet
                    data={sheetData}
                    setData={setSheetData}
                    enable_row_col={false}
                    readonly={true}
                />
            </CardContent>
        </Card>
    </>
}